import moment, { Moment } from 'moment';

export default (
  date: Moment,
  time: string,
  parseStrings: { date: undefined | string; time: undefined | string } = {
    date: undefined,
    time: undefined,
  },
) => {
  const formatStrings = {
    date: 'YYYY-MM-DD',
    time: 'HH:mm:ss',
  };

  const dateStr = moment(date, parseStrings.date).format(formatStrings.date);
  const timeStr = moment(time, parseStrings.time).format(formatStrings.time);

  return moment(
    `${dateStr} ${timeStr}`,
    `${formatStrings.date} ${formatStrings.time}`,
  );
};
